<template>
    <Toolbar />
    <div class="container-xxl attendance-list">
      <SncrBalanceBanner v-if="userAuth.id_prof" :professional-id="userAuth.id_prof"/>
      <TaskCards ref="taskCards" @open="openTask" />
      <div class="row">
        <div class="col-md-12">
          <div class="attendance-panel">

            <div class="attendance-list-toolbar">
              <div class="attendance-chip-group">
                <button
                    type="button"
                    class="attendance-chip"
                    :class="{ 'is-on': activeTab === 'tab-waiting' }"
                    @click="activeTab = 'tab-waiting'"
                >Pacientes em espera</button>
                <button
                    type="button"
                    class="attendance-chip"
                    :class="{ 'is-on': activeTab === 'tab-finished' }"
                    @click="activeTab = 'tab-finished'"
                >Finalizados</button>
              </div>
              <button v-if="userAuth.id_prof" type="button" class="attendance-chip"
                      data-bs-toggle="modal" data-bs-target="#sncrBalanceModal">
                <i class="bi bi-shield-check"></i>
                <span>Numerações Anvisa</span>
              </button>
            </div>

            <div class="attendance-panel__body">
              <p v-if="activeTab === 'tab-waiting'" class="attendance-muted">Pacientes que estão aguardando atendimento hoje</p>
              <p v-if="activeTab === 'tab-finished'" class="attendance-muted">Pacientes que foram atendidos hoje</p>

              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead>
                  <tr class="fw-bolder fs-6 text-gray-800">
                    <th>Nome</th>
                    <th>Agendamento</th>
                    <th>Chegada</th>
                    <th>Forma de pagamento</th>
                    <th>Especialidade</th>
                    <th class="text-center">Ações</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="text-center" v-if="schedulesFiltered.length <= 0">
                    <td colspan="12">
                      Nenhum paciente encontrado.
                    </td>
                  </tr>
                  <tr v-else v-for="schedule in schedulesFiltered" class="odd">
                    <td class="d-flex align-items-center">
                      <div class="symbol symbol-circle symbol-50px overflow-hidden me-3">
                        <div class="symbol-label">
                          <img class="w-50" :src="url(schedule?.patient?.patient_photo)" v-if="schedule?.patient?.patient_photo" alt="Foto do patiente">
                          <img class="w-50" :src="require('@/assets/images/no-photo.png')" alt="image" v-else/>
                        </div>
                      </div>
                      <div class="d-flex flex-column">
                        <span class="text-gray-800 text-hover-primary mb-1">
                          {{schedule?.patient?.patient_name}}
                        </span>
                        <span>{{schedule?.patient?.patient_email}}</span>
                        <div v-if="schedule?.sched_start && schedule?.sched_status !== 'FI'" class="badge badge-light-success fw-bolder">
                          Em Atendimento
                        </div>
                      </div>
                    </td>
                    <td>{{schedule?.sched_time}}</td>
                    <td>{{date(schedule?.sched_arrive_timezone).format('HH:mm:00')}}</td>
                    <td>
                      {{schedule?.payment_method?.paymeth_name}}
                      <span v-if="schedule?.payment_method?.is_insurance">
                        <br>
                        {{schedule?.insurance?.insurance_name}}
                      </span>
                    </td>
                    <td>
                      {{schedule?.specialty.spec_name}}
                      <div v-if="schedule?.sched_online" class="badge badge-light-success fw-bolder">
                        Online
                      </div>
                    </td>
                    <td class="text-center">
                      <button v-if="schedule?.professional_queue_arrivals?.length>0 && schedule?.sched_status !== 'FI'"
                              type="button" @click="callPatient(schedule)"
                              class="attendance-chip attendance-chip--icon"
                              :class="{ 'is-on': schedule?.professional_queue_arrivals[0].called_at }"
                              :title="!schedule?.professional_queue_arrivals[0].called_at ? 'Chamar paciente' : 'Chamar novamente'">
                        <i class="bi bi-megaphone"></i>
                      </button>
                      <button v-if="(schedule?.professional_queue_arrivals?.length===0 || schedule?.professional_queue_arrivals[0].called_at) && schedule?.sched_status !== 'FI'" type="button" @click="startAttendance(schedule)" class="attendance-chip attendance-chip--primary" title="Iniciar atendimento">
                        Iniciar
                      </button>

                      <BtnFinishOrReOpenSchedule
                          v-if="schedule?.sched_status === 'FI'"
                          :classes="'bi bi-check2-square btn-sm ' + (schedule?.sched_status === 'FI' ? 'btn-outline btn-outline-info' : 'btn-info')"
                          :scheduleEdit="schedule"
                          @onReopenSchedule="this.onReopenSchedule"
                          @onFinishSchedule="this.refreshData"
                      />

                      <BtnStartAttendanceSchedule
                          v-if="schedule?.sched_status === 'FI'"
                          :classes="schedule.sched_start ? 'btn-sm bi bi-arrow-clockwise' : 'btn-sm bi bi-play-fill'"
                          :scheduleEdit="schedule"
                      />

                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>

            </div>

          </div>
        </div>
      </div>
      <SncrModal v-if="userAuth.id_prof" :professional-id="userAuth.id_prof"/>
      <TaskModal :open="taskOpen" :focus-id="focusTaskId" @close="closeTask" @changed="refreshTasks" />
      <Teleport to="body">
      <div v-if="confirmSchedule" class="attendance-dialog" @mousedown.self="confirmSchedule = null">
        <div class="attendance-dialog__card" role="dialog" aria-modal="true">
          <header class="attendance-dialog__head">
            <h3>Iniciar atendimento</h3>
            <button type="button" class="attendance-chip attendance-chip--icon" title="Fechar" @click="confirmSchedule = null">
              <i class="bi bi-x-lg"></i>
            </button>
          </header>
          <p>Iniciar o atendimento de {{ confirmSchedule.patient?.patient_name }}?</p>
          <footer class="attendance-dialog__foot">
            <button type="button" class="attendance-chip" @click="confirmSchedule = null">Cancelar</button>
            <button type="button" class="attendance-chip attendance-chip--primary" @click="confirmStart">Iniciar</button>
          </footer>
        </div>
      </div>
      </Teleport>
  </div>
</template>

<script>
import http from "../../helpers/http";
import str from "../../helpers/str";
import Toolbar from "../../components/layouts/auth/Toolbar.vue";
import alert from "@/helpers/alert";
import BtnStartAttendanceSchedule from "../calendar/BtnStartAttendanceSchedule.vue";
import BtnFinishOrReOpenSchedule from "../calendar/BtnFinishOrReOpenSchedule.vue";
import SncrBalanceBanner from "../../components/sncr/SncrBalanceBanner.vue";
import SncrModal from "../../components/sncr/SncrModal.vue";
import TaskCards from "../tasks/TaskCards.vue";
import TaskModal from "../tasks/TaskModal.vue";

export default {
  name: "Attendance",
  components: {
    BtnFinishOrReOpenSchedule,
    BtnStartAttendanceSchedule,
    SncrBalanceBanner,
    SncrModal,
    TaskCards,
    TaskModal,
    Toolbar,
  },
  data() {
    return {
      search: '',
      activeTab: 'tab-waiting',
      schedules: [],
      confirmSchedule: null,
      taskOpen: false,
      focusTaskId: null,
    }
  },
  beforeUnmount() {
    if (this.userAuth.id_prof) {
      Echo.leave(`professionals.${this.userAuth.id_prof}.queues`);
    }
  },
  created() {
    this.getSchedules();
    this.wsConnect();
    this.loadSncrBalance();
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
    userAuth() {
      return this.$store.state.auth.user;
    },
    schedulesFiltered() {
      return this.schedules.filter(schedule => {
        const matchesSearch = JSON.stringify(schedule).toLowerCase().includes(this.search.toLowerCase());
        if (this.activeTab === 'tab-waiting') {
          return matchesSearch && schedule.sched_status !== 'FI';
        } else {
          return matchesSearch && schedule.sched_status === 'FI';
        }
      });
    },
    terminal() {
      return this.$store.state.auth.terminal;
    },
  },
  methods: {
    date: moment,
    url(path) {
      return str.url(path)
    },
    loadSncrBalance() {
      if (!this.userAuth.id_prof) {
        return;
      }

      this.$store.dispatch('sncr/load', {professionalId: this.userAuth.id_prof});
    },
    wsConnect() {
      if (!this.userAuth.id_prof) {
        return;
      }

      Echo.private(`professionals.${this.userAuth.id_prof}.queues`)
          .listen('ScheduleArrived', this.refreshData)
          .listen('ScheduleNotArrived', this.refreshData)
          .listen('ScheduleStarted', this.refreshData)
          .listen('ScheduleFinished', this.refreshData);
    },
    refreshData() {
      this.getSchedules();
    },
    getSchedules() {
      if (!this.userAuth.id_prof) {
        return;
      }

      http.get(`/places/${this.place.id_place}/professionals/${this.userAuth.id_prof}/attendance/schedules?include_finished=true`).then((response) => {
        this.schedules = response.data;
      });
    },
    openTask(taskId) {
      this.focusTaskId = taskId;
      this.taskOpen = true;
    },
    closeTask() {
      this.taskOpen = false;
      this.focusTaskId = null;
      this.refreshTasks();
    },
    refreshTasks() {
      this.$refs.taskCards?.load();
    },
    startAttendance(schedule) {
      if (schedule.sched_start) {
        this.goStart(schedule);
        return;
      }

      this.confirmSchedule = schedule;
    },
    confirmStart() {
      const schedule = this.confirmSchedule;
      this.confirmSchedule = null;
      this.goStart(schedule);
    },
    goStart(schedule) {
      http.patch(`/places/${this.place.id_place}/professionals/${this.userAuth.id_prof}/attendance/schedules/${schedule.id_sched}/start`).then(() => {
        this.$router.push({path: `/attendances/${schedule.id_sched}`});
      });
    },
    callPatient(schedule) {
      if (!schedule.professional_queue_arrivals?.length) {
        alert.toastError('Nenhum registro de chegada para este paciente.');
        return;
      }
      http.patch(
        `/places/${schedule.id_place}/queue-arrivals/${this.terminal.id_terminal}/call/${schedule.professional_queue_arrivals[0].id_queue_arrival}`
      ).then(response => {
        schedule.professional_queue_arrivals[0].called_at = response.data.called_at;
        schedule.professional_queue_arrivals[0].released_at = response.data.released_at;
        alert.toastSuccess('Paciente chamado com sucesso!');
      }).catch(error => {
        alert.toastError('Erro ao chamar paciente!');
        console.error('Erro ao chamar paciente:', error);
      });
    },
    onReopenSchedule() {
      this.refreshData();
      this.activeTab = 'tab-waiting';
    }
  }
}
</script>

<style scoped>
.attendance-list {
  --at-brand: #780f5a;
  --at-line: #e4e6ef;
  --at-muted: #7e8299;
  --at-ink: #181c32;
  --at-soft: #f8f5f7;
}
.attendance-panel {
  background: #fff;
  border: 1px solid var(--at-line);
  border-radius: 0.85rem;
}
.attendance-list-toolbar,
.attendance-dialog__head,
.attendance-dialog__foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}
.attendance-list-toolbar {
  padding: 0.9rem 1rem;
  border-bottom: 1px solid var(--at-line);
}
.attendance-panel__body {
  padding: 1rem;
}
.attendance-chip-group {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}
.attendance-chip {
  appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
  min-height: 2.4rem;
  margin: 0;
  padding: 0.45rem 0.9rem;
  border: 1px solid var(--at-line);
  border-radius: 0.5rem;
  background: #fff;
  color: var(--at-ink);
  font-size: 0.92rem;
  font-weight: 600;
  cursor: pointer;
  box-shadow: none;
}
.attendance-chip.is-on,
.attendance-chip:hover {
  border-color: var(--at-brand);
  color: var(--at-brand);
  background: var(--at-soft);
}
.attendance-chip--primary,
.attendance-chip--primary:hover {
  background: var(--at-brand);
  border-color: var(--at-brand);
  color: #fff;
}
.attendance-chip--icon {
  width: 2.4rem;
  padding: 0;
}
.attendance-muted {
  color: var(--at-muted);
}
.attendance-dialog {
  --at-brand: #780f5a;
  --at-line: #e4e6ef;
  --at-muted: #7e8299;
  --at-ink: #181c32;
  --at-soft: #f8f5f7;
  position: fixed;
  inset: 0;
  z-index: 2100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
  background: rgba(24, 28, 50, 0.38);
}
.attendance-dialog__card {
  width: 100%;
  max-width: 26rem;
  padding: 0.4rem 0 0.9rem;
  background: #fff;
  border: 1px solid var(--at-line);
  border-radius: 0.85rem;
  box-shadow: 0 18px 48px rgba(24, 28, 50, 0.18);
}
.attendance-dialog__head,
.attendance-dialog__foot,
.attendance-dialog p {
  padding-left: 1rem;
  padding-right: 1rem;
}
.attendance-dialog__head h3 {
  margin: 0;
  color: var(--at-ink);
  font-size: 1.05rem;
  font-weight: 800;
}
.attendance-dialog__foot {
  justify-content: flex-end;
}
@media (max-width: 767.98px) {
  .attendance-list-toolbar {
    align-items: stretch;
    flex-direction: column;
  }
}
</style>
